import React from 'react';

function App() {
  return (
    <div className="index">
    </div>
  );
}

export default App;
